import { Button, Card } from "@justworkshr/milo-core";
import {
  capitalize,
  getTotalGrossAmount,
  getTotalNumberOfPayees,
  getTypeDisplayValue,
  getExchangeRate,
  getActiveCurrency,
} from "pages/employer-of-record/payments/utils";
import { ReactElement, useContext } from "react";
import styles from "../../Review.module.css";
import { useFormikContext } from "formik";
import { AdditionalPayFormData, FormPayloadType } from "../../../Setup/types";
import { AdditionalPayContext } from "pages/employer-of-record/payments/contexts/additionalPayContext";
import { buildClockworkWebPath } from "lib/resource-finder";
import { CLOCKWORK_WEB_PATH } from "pages/employer-of-record/payments/constants";
import { toCurrencyFormat } from "pages/employer-of-record/utils";
import { EstimatedRateRow } from "../../../EstimatedRateRow/EstimatedRateRow";
import { SupportedCountriesContext } from "pages/employer-of-record/contexts/supportedCountriesContext";
import { ScheduleRow } from "../../../ScheduleRow/ScheduleRow";

const SummaryCard = ({ isEdit }: { isEdit: boolean }): ReactElement => {
  const { values, isSubmitting } =
    useFormikContext<AdditionalPayFormData<FormPayloadType>>();

  const additionalPayContext = useContext(AdditionalPayContext);
  const { supportedCountriesData } = useContext(SupportedCountriesContext);

  const countryInfo =
    supportedCountriesData[additionalPayContext?.selectedCountry || ""];

  if (!countryInfo) return <></>;
  const currencyData = getActiveCurrency(countryInfo.currencies);
  const currency = currencyData?.currencyCode || "";
  const type = getTypeDisplayValue(values.setUp.type);

  const totalGrossAmount = toCurrencyFormat(
    Number(getTotalGrossAmount(values.paymentDetails, currency)),
    currency || "",
    true,
    false,
    currencyData?.symbol
  );

  const exchangeRate = getExchangeRate(
    currency,
    additionalPayContext?.exchangeRates
  );

  return (
    <Card title="Summary">
      <div className={styles.summaryWrapper}>
        <div className={styles.summaryRow}>
          <div className={styles.rowLabel}>Payees</div>
          <div className={styles.rowValue}>
            {getTotalNumberOfPayees(values.paymentDetails)}
          </div>
        </div>
        <div className={styles.summaryRow}>
          <div className={styles.rowLabel}>Pay type</div>
          <div className={styles.rowValue}>{capitalize(type)}</div>
        </div>
        <ScheduleRow setup={values.setUp} />
        {exchangeRate && <EstimatedRateRow exchangeRate={exchangeRate} />}
        <div className={styles.summaryRow}>
          <div className={styles.rowLabel}>Gross amount</div>
          <div className={`${styles.rowValue} ${styles.grossAmount}`}>
            {totalGrossAmount}
          </div>
        </div>
      </div>
      <div className={styles.buttonWrapper}>
        <Button color="brand" type="submit" loading={isSubmitting}>
          {`${isEdit ? "Update" : "Submit"} Payment`}
        </Button>

        {!isEdit && (
          <Button
            color="brand"
            variant="outlined"
            type="button"
            onClick={() => {
              additionalPayContext?.setCurrentStep("payment-details");
            }}
          >
            Go back
          </Button>
        )}

        <Button
          variant="ghost"
          type="button"
          onClick={() => {
            window.location.assign(
              buildClockworkWebPath(CLOCKWORK_WEB_PATH.PAYMENTCENTER)
            );
          }}
        >
          Cancel
        </Button>
      </div>
    </Card>
  );
};

export default SummaryCard;
